import React from 'react';

export function UpSvg() {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 45 45"
      version="1.1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Artboard-Copy-66"
        stroke="none"
        strokeWidth="1"
        opacity="0.175742"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      >
        <g
          id="arrow-up-sm-svgrepo-com"
          transform="translate(13, 11)"
          stroke="#000000"
          fill="none"
          strokeWidth="4.66666667"
        >
          <path
            fill="none"
            d="M9.5,23 L9.5,0 M9.5,0 L0,9.2 M9.5,0 L19,9.2"
            id="Vector"
          />
        </g>
      </g>
    </svg>
  );
}
